<p-dialog [visible]="showUploadDialog()" [modal]="true" [closable]="false">
  <ng-template #header>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4>{{ title() }}</h4>
      </div>
    </div>
  </ng-template>

  <ng-template #content>

    @if(!options().uploaded) {
      <p-fileupload
        [name]="options().name"
        [url]="options().url"
        (onUpload)="onUpload($event)"
        (onSelect)="options().onSelect ? options().onSelect?.($event) : onSelect($event)"
        [multiple]="options().multiple"
        [accept]="options().accept"
        [maxFileSize]="options().maxFileSize"
        [mode]="options().mode"
      >
        <ng-template #empty>
          <div>Arrastra y suelta los archivos aquí para subir.</div>
        </ng-template>
      </p-fileupload>
    }
    @else {
      <div class="d-flex flex-column align-items-center">
        <i class="pi pi-check-circle" style="font-size: 2rem; color: green;"></i>
        <h5 class="mt-3">Archivo(s) subido(s) con éxito.</h5>

         <ng-container *ngFor="let it of options().uploadedFilesNames; let i = index">
          <a (click)="openWindowUploadHelp(it)">{{ it }}</a>
        </ng-container>
      </div> 
    }

  </ng-template>

  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="eventClose.emit()">
        Cerrar
      </button>
    </div>
  </ng-template>
</p-dialog>